import { OnDestroy } from '@angular/core';
import { empty, Subject, timer } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import * as i0 from "@angular/core";
var TimerService = /** @class */ (function () {
    function TimerService() {
        this._subrelease = new Subject();
        this._timers = [];
    }
    TimerService.prototype.ngOnDestroy = function () {
        // Stop all timers
        (this._timers || []).forEach(function (t) { return t.StopTimer(); });
        this._subrelease.next();
        this._subrelease.complete();
    };
    TimerService.prototype.CreateTimer = function (key, delay) {
        var self = this;
        // Get the highest ID number assigned to a timer in the list of known timers.
        var highestID = (!self._timers || !self._timers.length ? 1 :
            self._timers.map(function (t) { return t.TimerID; }).sort(function (a, b) { return a - b; })[0] + 1);
        var newTimer = (self._timers || []).find(function (t) { return t.Key === key; });
        if (newTimer == null) {
            // No timer already. Create a new one.
            newTimer = new Timer(key, highestID, delay);
            self._timers.push(newTimer);
        }
        else {
            // Timer is already existing. We'll return this one.
        }
        return newTimer;
    };
    TimerService.ngInjectableDef = i0.defineInjectable({ factory: function TimerService_Factory() { return new TimerService(); }, token: TimerService, providedIn: "root" });
    return TimerService;
}());
export { TimerService };
// #region Custom Classes
// #region Timer Class
var Timer = /** @class */ (function () {
    function Timer(key, tID, delay) {
        var _this = this;
        this._subrelease = new Subject();
        this.Delay = delay;
        this.Key = key;
        this.TimerID = tID;
        this._timerDelay = new Subject();
        this._timer = this._timerDelay.pipe(takeUntil(this._subrelease), switchMap(function (sdelay) { return sdelay ? timer(sdelay, sdelay) : empty(); }), map(function (t) {
            _this._timerTick = t;
            return {
                Key: _this.Key,
                Delay: _this.Delay,
                TimerID: _this.TimerID
            };
        }));
    }
    Object.defineProperty(Timer.prototype, "Timer", {
        get: function () {
            return this._timer;
        },
        enumerable: true,
        configurable: true
    });
    Timer.prototype.PauseTimer = function () {
        this._timerDelay.next(0);
    };
    Timer.prototype.StopTimer = function () {
        this._timerDelay.next(0);
        this._subrelease.next();
        this._subrelease.complete();
    };
    Timer.prototype.StartTimer = function (delay) {
        if (delay == null && this.Delay != null) {
            this._timerDelay.next(this.Delay);
        }
        else if (delay != null) {
            this.Delay = delay;
            this._timerDelay.next(delay);
        }
    };
    Timer.prototype.toString = function () {
        return "Timer: {Key: " + this.Key + ", TimerID: " + this.TimerID + ", Timer Value: " + this._timerTick + "}";
    };
    return Timer;
}());
export { Timer };
// #endregion
// #region Timer Info Class
var TimerInfo = /** @class */ (function () {
    function TimerInfo() {
    }
    return TimerInfo;
}());
export { TimerInfo };
